import Vue from "vue";
import Vuex from "vuex";
import concepts from "../../models/conceptos/concepts";
import service from "../../services/conceptos/concepts";
import moment from "moment";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    paddingNav: "10px",
    headers: {
      concepts: [],
      liquidation: [],
      csueldos: [],
    },
    concepts: [],
    liquidations: [],
    salaries: [],
    openConcepts: false,
    mode: "Agregar concepto",
    newConcept: {},
    editConcept: {},
    itemDelete: null,
    openDelete: false,
    modeSalaries: false,
    editSalaries: {},
    openSalaries: false,
    openDeleteSalaries: false,
    modeLiquidations: false,
    editLiquidations: {},
    openLiquidations: false,
    openDeleteLiquidations: false,
    itemDeleteLiquidations: null,
  },

  mutations: {
    setHeaders(state, data) {
      state.headers = data;
    },
    setPaddingNav(state, data) {
      state.paddingNav = data;
    },
    setConcepts(state, data) {
      state.concepts = data;
    },
    setOpenConcept(state, data) {
      state.openConcepts = data;
    },
    setOpenDelete(state, data) {
      state.openDelete = data;
    },
    setItemDelete(state, data) {
      state.itemDelete = data;
    },
    setMode(state, data) {
      state.mode = data;
    },
    setLiquidations(state, data) {
      state.liquidations = data;
    },
    setSalaries(state, data) {
      state.salaries = data;
    },
    setConcepts(state, data) {
      state.concepts = data;
    },
    setNewConcept(state, data) {
      state.newConcept = data;
    },
    setEditConcept(state, data) {
      state.editConcept = data;
    },
    setModeSalaries(state, data) {
      state.modeSalaries = data;
    },
    setEditSalaries(state, data) {
      state.editSalaries = data;
    },
    setOpenSalaries(state, data) {
      state.openSalaries = data;
    },
    setOpenDeleteSalaries(state, data) {
      state.openDeleteSalaries = data;
    },
    setModeLiquidations(state, data) {
      state.modeLiquidations = data;
    },
    setEditLiquidations(state, data) {
      state.editLiquidations = data;
    },
    setOpenLiquidations(state, data) {
      state.openLiquidations = data;
    },
    setOpenDeleteLiquidations(state, data) {
      state.openDeleteLiquidations = data;
    },
    setItemDeleteLiquidations(state, data) {
      state.itemDeleteLiquidations = data;
    },
  },
  actions: {
    async getColumsTableName(state, tableName) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getColumsTableName(tableName);
          let itemArray = JSON.parse(item.jsonData);
          state.commit("setColums", itemArray);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getConcepts(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let items = await state.state.service.getConceptos();
          const filteredItems = items.filter((item) => item.name !== "REGIS");
          state.commit("setConcepts", filteredItems);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async getConceptId({ state, commit }, conceptoId) {
      try {
        const data = await state.service.getConceptoId(conceptoId);
        commit("setEditConcept", data);
        return true;
      } catch (error) {
        throw error;
      }
    },

    async getLiquidationModels(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getLiqModelos();
          state.commit("setLiquidations", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async getSalaries(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getSueldos();
          state.commit("setSalaries", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async addConcept(state) {
      try {
        const response = await state.state.service.addConcepto(
          state.state.newConcept
        );
        const newItem = concepts.fromJson(response.data);
        const updatedConcepts = [newItem, ...state.state.concepts];
        state.commit("setConcepts", updatedConcepts);
        return true;
      } catch (error) {
        throw error;
      }
    },

    async deleteConcept(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteConcepto(state.state.itemDelete)
            .then(() => {
              let options = state.state.concepts;
              options = options.filter((option) => {
                return option.conceptId != state.state.itemDelete;
              });
              state.commit("setConcepts", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    async editConcept(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editConcepto(state.state.editConcept)
            .then(() => {
              let item = state.state.editConcept;
              let options = state.state.concepts;
              options = options.map((option) => {
                if (option.conceptoId !== item.conceptoId) {
                  return option;
                }
                item = concepts.fromJson({
                  conceptoId: item.conceptId,
                  nombre: item.nombre,
                  licTot: item.fullDayLicense,
                  horTrab: item.workHours,
                  redondeaLiq: item.roundSalary,
                  denegarAcceso: item.denyAccess,
                });
                return item;
              });

              state.commit("setConcepts", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    async addSalarie(state) {
      try {
        const response = await state.state.service.addSalarieToConcept(
          state.state.newConcept
        );
        const newSalarie = response.data;
        const nombreReloj = state.state.salaries.find(
          (salarie) => salarie.id === newSalarie.cSueldoId
        );
        const formattedNewClock = {
          ...newSalarie,
          nombre: nombreReloj.name,
          fecDesde: moment.utc(newSalarie.fecDesde).format("DD-MM-YYYY"),
          fecHasta: newSalarie.fecHasta
            ? moment.utc(newSalarie.fecHasta).format("DD-MM-YYYY")
            : "",
        };

        const updatedEdit = {
          ...state.state.editConcept,
          cSueldos: [...state.state.editConcept.cSueldos, formattedNewClock],
        };
        state.commit("setEditConcept", updatedEdit);
        return true;
      } catch (error) {
        throw error;
      }
    },

    async deleteSalarie(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteSalarieToConcept(state.state.itemDelete)
            .then(() => {
              let options = state.state.editConcept.cSueldos;
              options = options.filter((option) => {
                return (
                  option.cSueldoId !== state.state.itemDelete.cSueldoId ||
                  option.nombre !== state.state.itemDelete.nombre ||
                  option.fecDesde !== state.state.itemDelete.fecDesde ||
                  option.fecHasta !== state.state.itemDelete.fecHasta
                );
              });

              let edit = { ...state.state.editConcept };
              edit.cSueldos = options;
              state.commit("setEditConcept", edit);

              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    async editSalarie(state) {
      try {
        await state.state.service.editSalarieToConcept(
          state.state.editSalaries
        );
        const editedSalarie = state.state.editSalaries;
        const options = state.state.editConcept.cSueldos.map((option) => {
          if (option.cSueldoId === editedSalarie.oldItems.cSueldoId) {
            return {
              fecDesde: moment.utc(editedSalarie.fecDesde).format("DD-MM-YYYY"),
              fecHasta: editedSalarie.fecHasta
                ? moment.utc(editedSalarie.fecHasta).format("DD-MM-YYYY")
                : "",
              nombre: editedSalarie.oldItems.nombre,
            };
          }
          return option;
        });

        const editedConcept = {
          ...state.state.editConcept,
          cSueldos: options,
        };

        state.commit("setEditConcept", editedConcept);
        return true;
      } catch (error) {
        throw error;
      }
    },

    async addLiquidation(state) {
      try {
        const response = await state.state.service.addLiquidationToConcept(
          state.state.newConcept
        );
        const newLiquidation = response.data;
        const nombreLiquidacion = state.state.liquidations.find(
          (liquidation) => liquidation.liqmodelId === newLiquidation.liqModeloId
        );
        const formatted = {
          name: nombreLiquidacion.name,
          auth: newLiquidation.autoriza === true ? "✔️" : "",
          id: newLiquidation.liqModeloId,
        };

        const updatedEdit = {
          ...state.state.editConcept,
          liqModelos: [...state.state.editConcept.liqModelos, formatted],
        };
        state.commit("setEditConcept", updatedEdit);
        return true;
      } catch (error) {
        throw error;
      }
    },

    async deleteLiquidation(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteLiquidationToConcept(state.state.itemDeleteLiquidations)
            .then(() => {
              let options = state.state.editConcept.liqModelos;
              options = options.filter((option) => {
                return option.id !== state.state.itemDeleteLiquidations.id;
              });

              let edit = { ...state.state.editConcept };
              edit.liqModelos = options;
              state.commit("setEditConcept", edit);

              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async editLiquidation(state) {
      try {
        await state.state.service.editLiquidationToConcept(
          state.state.editLiquidations
        );

        let item = state.state.editLiquidations;
        let options = state.state.editConcept.liqModelos;

        options = options.map((option) => {
          if (option.id === Number(item.liqModelos)) {
            return {
              id: Number(item.liqModelos),
              name: option.name,
              auth: item.auth === "true" ? "✔️" : "",
            };
          }
          return option;
        });

        const editedConcept = {
          ...state.state.editConcept,
          liqModelos: options,
        };

        state.commit("setEditConcept", editedConcept);
        return true;
      } catch (error) {
        throw error;
      }
    },
  },
});
